import React, { createContext, useContext, useState, useCallback } from "react";
const SnPlanContext = createContext();

export const SnPlanProvider = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(0);
 
  return (
    <SnPlanContext.Provider value={{ currentStep, setCurrentStep }}>{children} </SnPlanContext.Provider>
  );
};

export const useSnPlanStep = () => useContext(SnPlanContext);
